import type { VAxios } from '../../define/axios/Axios';

/**
 * 内容中心接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  // #region 百灵生成记录 log
  bailingGeneratorLog: (params) => {
    return defHttp.post({
      url: `/aiad/bailing/generates/logs`,
      params,
    });
  },

  bailingGenerateSync: (params: { ability: string; prompt: string }) => {
    return defHttp.post({
      url: `/aiad/bailing/generates`,
      params,
    });
  },
  //#endregion
});
